// extracted by mini-css-extract-plugin
export default {"notApprovableContainer":"NotApprovableItems__notApprovableContainer___EMT6D","disclaimer":"NotApprovableItems__disclaimer___XBN3f","table":"NotApprovableItems__table___QUA2S"};